import type { ProductRecord, PromotionRecord } from "@/api/inventory";

/**
 * Misma regla que `promotion.service.ts::getActivePromotionsForProducts` en
 * el backend (vigente = activa y hoy dentro de [startDate, endDate]; un
 * producto específico gana sobre una de categoría) — se replica aquí solo
 * para mostrar el mismo precio/descuento que va a cobrar el backend; el
 * backend sigue siendo la única fuente de verdad al confirmar la venta.
 * Compartido entre PosPage (carrito) y PriceCheckPage (validador de precios).
 */
export function resolvePromotion(product: ProductRecord, promotions: PromotionRecord[] | undefined): PromotionRecord | undefined {
  if (!promotions?.length) return undefined;
  const today = new Date().toISOString().slice(0, 10);
  const isValid = (p: PromotionRecord) => (!p.startDate || p.startDate <= today) && (!p.endDate || p.endDate >= today);
  const productMatch = promotions.find((p) => p.isActive && isValid(p) && p.productId === product.id);
  if (productMatch) return productMatch;
  if (!product.categoryId) return undefined;
  return promotions.find((p) => p.isActive && isValid(p) && p.categoryId === product.categoryId);
}

export function discountPerUnit(product: ProductRecord, promotion: PromotionRecord | undefined): number {
  if (!promotion) return 0;
  const unitPrice = Number(product.salePrice);
  return promotion.discountType === "PERCENTAGE" ? unitPrice * (Number(promotion.value) / 100) : Math.min(Number(promotion.value), unitPrice);
}
